import React from 'react'
import BannerImg from "../../assets/images/m-banner.webp"

function MiddleBanner() {
  return (
    <div className='m-banner-wrapper'>
      <img className='img-fluid m-banner-img' src={BannerImg} alt='Banner image' width={"100%"} height={500} />
      <div className='m-banner-content'>
        <h3 className='m-banner-text'>Discover Qatar</h3>
      </div>
    </div>
  )
}

export default MiddleBanner